import script from "./communityStat.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityStat.vue?vue&type=script&lang=ts&setup=true"

import "./communityStat.vue?vue&type=style&index=0&id=740e6075&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-740e6075"]])

export default __exports__